<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="label != ''"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                >
                {{ label }}
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-h5" v-if="method=='create'">Registar feature</span>
                    <span class="text-h5" v-else>Editar feature</span>
                </v-card-title>
                <v-card-text>
                    <validation-observer ref="form_feature" v-slot="{ }">      
                    <v-form class="mb-16" @submit.prevent="addFeature">
                        <fieldset :disabled="loading">
                        
                        </fieldset>         
                    </v-form>
                    </validation-observer>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <DialogSuccess :opened="success" @on-ok="onSuccess" >
            Feature gravada com sucesso
        </DialogSuccess>
    </v-row>
  </template>
  <script>

  import DialogSuccess from '@/components/ui/DialogSuccess.vue';
  
  export default {
    components:{
        DialogSuccess,
    },
    props:{
        label: {
            Type: String,
            default: ''
        },
        tenant:{
            Type: String,
            default: null
        },
        method:{
            Type: String,
            default: 'create'
        },
        selectedFeature:{
            default: null
        }
    },
    watch:{
        selectedFeature:{
            immediate: true,
            handler(val){
                if(!val) {
                return;
                }

                let data = {...val};

                this.fields = data;

                this.fields.id = data.id;
                
            }
        }
    },
    data(){
        return{
            dialog: false,
            loading: false,         
            success: false, 
            fields: {
                id: null,
                name: null,
                display_name:null,
                users:[],
                permissions: [],
            },
        }
    },
    methods:{
        onSuccess() {
            this.dialog = false
            this.success = false
            this.$emit('reloadFeatures')
        },
        openDialog(){
            this.dialog = true
        },
        addFeature(){         
            
        },
    }
  }
  </script>